import { c as _c } from "react/compiler-runtime";
import { Button, Input, InputGroup, Text, Wrap } from '@chakra-ui/react';
import { CurrencyInput } from '@src/components/sco/CurrencyInput';
import { DiagnosticColumns } from '@src/components/sco/Funding/FundingLandingDiagnostic/DiagnosticShell';
import { AccentHeading, ChoiceChip, FieldLabel, Panel, ProofStats, WhyWeAsk } from '@src/components/sco/Funding/FundingLandingDiagnostic/shared';
import { RAISE_PRESETS } from '@src/components/sco/Funding/FundingLandingDiagnostic/types';
import { useRequestFunnelContext } from '@src/components/sco/RequestFunnel/RequestFunnelContext';
import tracker from '@src/lib/tracker';
import React, { useEffect } from 'react';
import { LuChevronRight } from 'react-icons/lu';
export const AmountStep: React.FC = () => {
  const $ = _c(26);
  const {
    signupRequest,
    updateSignupRequest,
    setStep
  } = useRequestFunnelContext();
  const amount = signupRequest.fundingGoalInDollars ?? 500000;
  let t0;
  if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
    t0 = [];
    $[0] = t0;
  } else {
    t0 = $[0];
  }
  useEffect(_temp, t0);
  let t1;
  if ($[1] === Symbol.for("react.memo_cache_sentinel")) {
    t1 = <AccentHeading accent="funded." line1="Let's get you" />;
    $[1] = t1;
  } else {
    t1 = $[1];
  }
  let t2;
  if ($[2] === Symbol.for("react.memo_cache_sentinel")) {
    t2 = <>{t1}<WhyWeAsk title="Here's what you get" items={["Investors matched to your raise", "Names + direct contact info", "Ranked by who actually replies"]} /><ProofStats /></>;
    $[2] = t2;
  } else {
    t2 = $[2];
  }
  let t3;
  if ($[3] === Symbol.for("react.memo_cache_sentinel")) {
    t3 = <FieldLabel>How much capital do you need?</FieldLabel>;
    $[3] = t3;
  } else {
    t3 = $[3];
  }
  let t4;
  if ($[4] !== updateSignupRequest) {
    t4 = value => updateSignupRequest({
      fundingGoalInDollars: value
    });
    $[4] = updateSignupRequest;
    $[5] = t4;
  } else {
    t4 = $[5];
  }
  let t5;
  if ($[6] !== amount || $[7] !== t4) {
    t5 = <InputGroup startAddon="$" width="full"><Input asChild={true} fontFamily="heading" fontSize="2xl" fontWeight="bold" size="lg" textAlign="start"><CurrencyInput decimalPlaces={0} numericValue={amount} onNumericValueChange={t4} /></Input></InputGroup>;
    $[6] = amount;
    $[7] = t4;
    $[8] = t5;
  } else {
    t5 = $[8];
  }
  let t6;
  if ($[9] !== amount || $[10] !== updateSignupRequest) {
    t6 = RAISE_PRESETS.map(preset => <ChoiceChip key={preset.label} active={amount === preset.value} onClick={() => updateSignupRequest({
      fundingGoalInDollars: preset.value
    })}>{preset.label}</ChoiceChip>);
    $[9] = amount;
    $[10] = updateSignupRequest;
    $[11] = t6;
  } else {
    t6 = $[11];
  }
  let t7;
  if ($[12] !== t6) {
    t7 = <Wrap gap={2} justify="flex-start" marginTop={2}>{t6}</Wrap>;
    $[12] = t6;
    $[13] = t7;
  } else {
    t7 = $[13];
  }
  let t8;
  if ($[14] === Symbol.for("react.memo_cache_sentinel")) {
    t8 = <Text color="fg.muted" fontSize="xs" marginTop={1} textAlign="start">(You can modify later)</Text>;
    $[14] = t8;
  } else {
    t8 = $[14];
  }
  let t9;
  if ($[15] !== t5 || $[16] !== t7) {
    t9 = <Panel>{t3}{t5}{t7}{t8}</Panel>;
    $[15] = t5;
    $[16] = t7;
    $[17] = t9;
  } else {
    t9 = $[17];
  }
  let t10;
  if ($[18] !== setStep) {
    t10 = () => setStep("startup");
    $[18] = setStep;
    $[19] = t10;
  } else {
    t10 = $[19];
  }
  let t11;
  if ($[20] === Symbol.for("react.memo_cache_sentinel")) {
    t11 = <LuChevronRight />;
    $[20] = t11;
  } else {
    t11 = $[20];
  }
  let t12;
  if ($[21] !== t10) {
    t12 = <Button fontWeight="bold" size="xl" variant="cta" width="full" onClick={t10}>Find my Investors{t11}</Button>;
    $[21] = t10;
    $[22] = t12;
  } else {
    t12 = $[22];
  }
  let t13;
  if ($[23] !== t12 || $[24] !== t9) {
    t13 = <DiagnosticColumns left={t2} right={<>{t9}{t12}</>} />;
    $[23] = t12;
    $[24] = t9;
    $[25] = t13;
  } else {
    t13 = $[25];
  }
  return t13;
};
function _temp() {
  tracker.funnelStep(0);
}